import React, { useEffect, useReducer, useRef, useState } from 'react';
import { TreatmentFilterModel, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';
import Pagger from '../components/_Pagger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faMagnifyingGlass, faWrench, faXmark } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { Dropdown, MenuProps, Select } from 'antd';
import TasksTable from '../tasks/_TasksTable';
import { useFetcher } from 'react-router-dom';
import { set } from 'lodash';
import { SimulatorModel } from '../models/SimulatorModel';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setLoadTasks, setPopUpTreatmentModel, setTask, setTreatmentId } from '../app-context/tasksSlice';
import TasksSendEmailPopup from '../tasks/_TasksSendEmailPopup';
import TasksSendWhatsAppPopup from '../tasks/_TasksSendWhatsAppPopup';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import ConfirmPopUp from '../tasks/_ConfirmPopup';
import { TaskDocumentPopup } from '../tasks/_TaskDocumentPopup';


interface TasksClientDetailsProps {
    treatmentsList: any[];
    customerId: string;
    setLoading: Function;
    showTreatmentConfigPopup: () => void;
    showAddTreatmentPopup: (type: number) => void;
}

const TasksClientDetails: React.FC<TasksClientDetailsProps> = (props: TasksClientDetailsProps) => {


    const loadTasks = useSelector((state: RootState) => state.tasks.loadTasks);

    const dispatch = useDispatch();

    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();

    const [treatmentsSeachText, setTreatmentsSearchText] = useState<string>('');
    const [treatmentsFilter, setTreatmentsFilter] = useState<TreatmentFilterModel>(
        new TreatmentFilterModel({
            page: 1,
            customerId: props.customerId
        })
    );
    const [treatmentsList, setTreatmentsList] = useState<any[]>();
    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);
    const [treatmentSeachType, setTreatmentSeachType] = useState<string>('-1');
    const [treatmentSearchHandledBy, setTreatmenSearchHandledBy] = useState<string>('-1');
    const [treatmentSearchCreatedBy, setTreatmenSearchCreatedBy] = useState<string>('-1');
    const [showTreatmentsAdvancedSearch, setShowTreatmentsAdvancedSearch] = useState<boolean>(false);
    const [treatmentsPeriod, setTreatmentsPeriod] = useState<string>('-1');
    const [treatmentsStartDate, setTreatmentsStartDate] = useState<Date | null>(null)
    const [treatmentsEndDate, setTreatmentsEndDate] = useState<Date | null>(null)
    const [treatmentsPagerConf, setTreatmentsPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [creatorsOptions, setCreatorsOptions] = useState<any[]>([]);
    const [handlersOptions, setHandlersrsOptions] = useState<any[]>([]);
    const [sortBy, setSortBy] = useState<any | undefined>({
        property: "endDate",
        SortDirection: "ASC"
    });
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([])

    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 0,
        totalItems: 0
    });
    const [currentPage, setCurrentPage] = useState<number>(1)

    const [showSendEmailPopUp, setShowSendEmailPopUp] = useState<boolean>(false);
    const [showSendWhatsAppPopUp, setShowSendWhatsAppPopUp] = useState<boolean>(false);
    const [documentUrl, setDocumentUrl] = useState<any[]>([]);

    // delete assignment popup
    const [assignmentIdForDelete, setAssignmentIdForDelete] = useState<string | null>(null)
    const [showDeleteAssignmentPopUp, setShowDeleteAssignmentPopup] = useState<boolean>(false);
    const [popupMessageContent, setPopupMessageContent] = useState<string | null>(null)
    const [popupMessageTitle, setPopupMessageTitle] = useState<string | undefined>(undefined);


    useEffect(() => {
        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            setCreatorsOptions(buildOptionsForSelect(JSON.parse(creatorsList), 'id', 'כל היוצרים'))
            // const source = JSON.parse(creatorsList);
        }
        const handlersList = localStorage.getItem('handlersList');
        if (handlersList) {
            setHandlersrsOptions(buildOptionsForSelect(JSON.parse(handlersList), 'id', 'כל מטפלים'))
            // const source = JSON.parse(handlersList);
        }

        fetchAgentsData();


    }, [])


    useEffect(() => {

        if (loadTasks) {
            getTreatments();
            dispatch(setLoadTasks(false));
        }
    }, [loadTasks == true])


    const fetchAgentsData = async () => {
        var agentsData: any[] = [];
        let agentsDataStorage = localStorage.getItem('agents');
        if (agentsDataStorage) {
            agentsData = JSON.parse(agentsDataStorage);
        } else {
            agentsData = await simulatorModel.getCustomerCardAgents();
            localStorage.setItem('agents', JSON.stringify(agentsData));
        }

        setAgents(agentsData);
        setAgentsList(agentsData.map((a: any) => {
            return {
                value: a.id,
                label: a.name
            }
        }))
    }

    useEffect(() => {
        setTreatmentsList(props.treatmentsList);
        // getTreatments();
    }, [props.treatmentsList])

    const buildOptionsForSelect = (source: any[], param: string = 'id', label: string = 'הכל') => {
        const items: any[] = [
            {
                label: label,
                value: '-1'
            }];
        source.forEach((i: any) => {
            items.push(
                {
                    label: i.fullName,
                    value: i[param]
                }
            );
        })
        // console.log('buildOptionsForSelect', items);
        return items.sort((a: any, b: any) => {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        });
    }


    const getTreatments = async (filter?: TreatmentFilterModel) => {
        props.setLoading(true);
        setTreatmentsList([]);
        if (!filter) {
            filter = treatmentsFilter;
        }
        console.log('getTreatments', filter)
        const treatmentsData = await customerCardModel.treatmentsFilter(filter);
        const treatments: any[] = [];
        if (treatmentsData.items && treatmentsData.items.length > 0) {
            treatmentsData.items.forEach((item: any) => {
                if (item.treatmentActivities && item.treatmentActivities.length > 0) {
                    const lastActivity = item.treatmentActivities[item.treatmentActivities.length - 1];
                    if (lastActivity && lastActivity.createdById !== '') {
                        item.updatedBy = lastActivity.createdBy;
                        item.updatedById = lastActivity.createdById;
                    }
                }
                treatments.push(item);
            })
        }
        const treatmentsSorted = treatments.sort((a: any, b: any) => {
            const dateA = new Date(a.createdDate);
            const dateB = new Date(b.createdDate);
            // Sort by eventDate in descending order
            return dateB.getTime() > dateA.getTime() ? 1 : -1;
        });

        console.log('treatmentsData', treatmentsData, treatmentsSorted);
        setTreatmentsList(treatmentsSorted);
        props.setLoading(false);
    }


    // treatments function

    const handleTreatmentSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setTreatmentsSearchText(newSearchText);
        const newFilter = treatmentsFilter;
        newFilter.searchTerm = newSearchText;
        setTreatmentsFilter(newFilter);

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            getTreatments(newFilter);
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);
    };

    const setFilterTreatmentType = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        const newFilter = treatmentsFilter;
        if (value !== '-1') {
            newFilter.treatmentType = parseInt(value);
        } else {
            newFilter.treatmentType = undefined
        }
        setTreatmentSeachType(value)
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);

    }
    const clearTreatmentsFliter = () => {
        const newFilter = new TreatmentFilterModel({
            page: 1,
            customerId: props.customerId,
            searchTerm: undefined,
            userId: undefined,

        });
        setTreatmentSeachType('-1');
        setTreatmentsSearchText('');
        setTreatmenSearchHandledBy('-1');
        setTreatmenSearchCreatedBy('-1');
        setTreatmentsStartDate(null);
        setTreatmentsEndDate(null);
        setTreatmentsPeriod('-1');
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }

    const onSearchHandler = (value: string) => {
        console.log('onSearch', value)
        const option = handlersOptions.find((a: any) => a.label == value);
        console.log('option', option)
        const newFilter = treatmentsFilter;
        if (option) {
            newFilter.handlerId = option.value;
            setTreatmenSearchHandledBy(value);
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.handlerId = undefined
            setTreatmentsFilter(newFilter);
        }
    }

    const onTreatmentHandlerChange = (value: string) => {
        console.log('onTreatmentHandlerChange value', value)
        const option = handlersOptions.find((a: any) => a.value == value);
        console.log('onTreatmentHandlerChange option', option)

        const newFilter = treatmentsFilter;
        if (option) {

            newFilter.handlerId = option.value != '-1' ? option.value : undefined;
            setTreatmenSearchHandledBy(value)
            console.log('onTreatmentHandlerChange', newFilter)
            setTreatmentsFilter(newFilter);

            getTreatments(newFilter);
            // setTreatmenSearchHandledBy(option.label)
        } else {
            newFilter.handlerId = undefined
            setTreatmentsFilter(newFilter);

        }

    }


    const onSearchCreator = (value: string) => {
        console.log('onSearch', value)
        const option = handlersOptions.find((a: any) => a.label == value);
        console.log('option', option)
        const newFilter = treatmentsFilter;
        if (option) {
            newFilter.employerId = option.value;
            setTreatmenSearchCreatedBy(value);
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.employerId = undefined
            setTreatmentsFilter(newFilter);
        }
    }


    const onTreatmentCreatorChange = (value: string) => {
        const option = handlersOptions.find((a: any) => a.value == value);
        const newFilter = treatmentsFilter;
        if (option) {
            newFilter.employerId = option.value != '-1' ? option.value : undefined;
            setTreatmenSearchCreatedBy(value)
            setTreatmentsFilter(newFilter);
            getTreatments(newFilter);
        } else {
            newFilter.employerId = undefined
            setTreatmentsFilter(newFilter);
        }
    }

    // const onTreatmentCreatorChange = (value: string, option: { label: string; value: string; }) => {
    //     const newFilter = treatmentsFilter;
    //     if (value !== '-1') {
    //         newFilter.employerId = value;
    //     } else {
    //         newFilter.employerId = undefined
    //     }
    //     setTreatmenSearchCreatedBy(option.label)
    //     setTreatmentsFilter(newFilter);
    //     getTreatments(newFilter);
    // }


    const onTreatmentStartDateChange = (d: Date) => {
        setTreatmentsStartDate(d);
        const newFilter = treatmentsFilter;
        newFilter.dateFrom = d;
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }
    const onTreatmentEndDateChange = (d: Date) => {
        setTreatmentsEndDate(d);
        const newFilter = treatmentsFilter;
        newFilter.dateTo = d;
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
    }


    const onTreatmentPeriodChange = (value: string, option: { label: string; value: string; }) => {
        let start: Date | null = null;
        let end: Date | null = new Date();
        switch (value) {
            case '3months':
                start = moment().subtract(3, 'months').toDate();
                break;
            case '6months':
                start = moment().subtract(6, 'months').toDate();
                break;
            case '12months':
                start = moment().subtract(3, 'months').toDate();
                break;
            case '3years':
                start = moment().subtract(3, 'years').toDate();
                break;
            default:
                start = null;
                end = null;
                break;
        }
        setTreatmentsPeriod(value);
        const newFilter = treatmentsFilter;
        if (value !== '-1') {
            newFilter.dateFrom = start ? start : undefined;
            newFilter.dateTo = end ? end : undefined;
        } else {
            newFilter.dateFrom = undefined;
            newFilter.dateTo = undefined;
        }
        setTreatmentsStartDate(start);
        setTreatmentsEndDate(end);
        setTreatmentsFilter(newFilter);
        getTreatments(newFilter);
        // setShowTreatmentsAdvancedSearch(false);
    }

    const onAddOfferOptionClick = (type: number) => {
        if (props.showAddTreatmentPopup) {
            props.showAddTreatmentPopup(type);
            // switch (type) {
            //     case TreatmentType._0: // Call
            //         props.config.showAddTreatmentPopup(type);
            //         break;  
            //     case TreatmentType._3: // Email
            //         props.config.showAddTreatmentPopup(type);
            //         break;          
            //     default:
            //         props.config.showAddTreatmentPopup(type);
            //         break;
            // }
        }
    }

    const onShowDocumentPopUp = (url: any[]) => {
        console.log('onShowDocument-onShowDocumentPopUp', url)
        setDocumentUrl(url);
    }

    const onHideDocumentPopUp = () => {
        setDocumentUrl([]);
    }


    const editTask = async (id?: string) => {
        if (!id) {
            let newTreatment =
            {
                "id": null,
                "createdDate": null,
                "eventDate": null,
                "alertDate": null,
                "treatmentType": 0,
                "topic": "",
                "note": "2",
                "filePath": null,
                "customerId": null,
                "customer": null,
                "from": "",
                "to": "",
                "cc": "",
                "bcc": "",
                "assignmentStatus": null,
                "policyRelatedId": null,
                "policyRelated": null,
                "sueRelatedId": null,
                "sueRelated": null,
                "leadRelatedId": null,
                "leadRelated": null,
                "relationEntitiesModel": null,
                "agentId": null,
                "agent": null,
                "userId": null,
                "user": null,
                "startDate": null,
                "endDate": null,
                "fileAttachment": null,
                "customersIds": null,
                "leadsIds": null,
                "companyId": null,
                "company": null,
                "priority": null,
                "treatmentOutcome": null,
                "emailDeliveryType": null,
                "address": null,
                "smsFrom": null,
                "smsTo": null,
                "smsMessage": null,
                "smsPhone": null,
                "smsSenderId": null,
                "faxPhone": null,
                "sentByFax": null,
                "faxBy": null,
                "faxInHonorOf": null,
                "statusChangeEmail": null,
                "statusChangeSms": null,
                "location": null,
                "includeLogo": false,
                "emailBody": "",
                // "emailBody": "KYUSHU PLUS 4X2 (1987) היברידי רגיל פנאי-שטח;;;<p><span style=\"font-size:16px\"><strong><u>ביטוח מסוג מקיף כולל כיסוי תאונה וגניבה </u></strong></span></p>\r\n\r\n<p><span style=\"font-size:16px\"><u>הביטוח כולל:</u></span></p>\r\n\r\n<ul dir=\"rtl\">\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData3</span></span></li>\r\n\t<li><span style=\"font-size:16px\">התחייבות לתיקון בחלפים מקוריים במוסך מורשה לקסוס.</span></li>\r\n\t<li><span style=\"font-size:16px\">גרירה ושרותי דרך 24 שעות ביממה- ממסי בטלפון 5202*. (כולל החלפת גלגל, גרירה מכביש 6 ומחניונים)</span></li>\r\n\t<li><span style=\"font-size:16px\">החזר הוצאות נסיעה ממקום התאונה עד 250 שח , במידה והרכב אינו במצב נסיעה.</span></li>\r\n\t<li><span style=\"font-size:16px\">כיסוי שבר שמשות סטנדרטי (לא מקורי) ללא השתתפות עצמית</span></li>\r\n\t<li><span style=\"font-size:16px\">רכב חליפי לקסוס* : לנהגים מגיל 24 מעל שנה ותק נהיגה :&nbsp;בתאונה - רכב חליפי במוסך הסדר לקסוס &nbsp;מפתח תמורת מפתח.&nbsp;בגניבה או טוטאלוסט -30 יום או עד קבלת תשלום מחברת הביטוח (המוקדם מביניהם)</span></li>\r\n\t<li><span style=\"font-size:16px\">גבול אחריות לפגיעה בצד ג&#39; 1,500,000 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">כינון אוטומט במוסך הסדר - ללא תוספת פרמיה.</span></li>\r\n\t<li><span style=\"font-size:16px\">הרכב יחשב לאובדן כללי בנזק מעל 50% בלבד.</span></li>\r\n\t<li><span style=\"font-size:16px\">השתתפות עצמית במוסכי הסדר לקסוס :&nbsp;לרכב בשווי עד 350000 שח &nbsp;1390 ₪ , לנהגים עד גיל 21 &nbsp;)לא חדשים) 2092 ש&quot;ח, לנהגים מגיל 17 או לנהגים חדשים 2794 ₪ &#39;&nbsp;&nbsp;לרכב בשווי מעל 350000 שח : 2000 ₪ , &nbsp; &nbsp; לנהגים 17+ או נהגים חדשים 3000 ₪ .</span></li>\r\n\t<li dir=\"RTL\" style=\"text-align:right\"><span style=\"font-size:16px\"><span style=\"font-family:&quot;Times New Roman&quot;,&quot;serif&quot;\"><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">השתתפות עצמית בירידת ערך 1.5%</span><span dir=\"LTR\" style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">.</span><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\"> ברכבים בשווי מעל 350000 שח- השתתפות עצמית בירידת ערך 5%.</span></span></span></li>\r\n\t<li><span style=\"font-size:16px\">הגנה משפטית עד 50,000 ₪. ה&quot;ע 200 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">ביטוח תוספות ואבזור ברכב עד 10,000 ₪ ללא תוספת פרמיה בכפוף להצגת חשבונית בגין האביזרים טרם עריכת הביטוח .</span></li>\r\n\t<li><span style=\"font-size:16px\">שירות VIP ללקוחות הקולקטיב 24 שעות ביממה בטלפון 8099*.</span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData1</span></span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData2</span></span></li>\r\n</ul>\r\n\r\n<p dir=\"RTL\"><span style=\"font-size:16px\">*רכב חליפי לקסוס או לחילופין רכב מנהלים&nbsp;על בסיס&nbsp;&nbsp;זמינות המשכיר.</span></p>\r\n\r\n<p>&nbsp;</p>\r\n;;;<p dir=\"RTL\"><span style=\"font-size:14px\"><strong><u>הביטוח מותנה וכפוף</u></strong><strong><u>:</u></strong></span></p>\r\n\r\n<ul>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">באישור העדר תביעות ביטוח מקיף 3 שנים אחרונות &ndash; יש להציג אישור תוך 7 ימים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">אישור בדיקת מיגון הנדרש ע&quot;י חברת הביטוח.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">כל הכיסויים בכפוף לתנאי הפוליסה ולכתבי השירות הרלוונטיים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">את הביטוח מקיף ניתן לחלק ב-4 תש&#39; ללא ריבית וחובה ב-12 תש&#39; ללא ריבית.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">חלק מהכיסויים נמכרים ללא מעורבות חב&#39; הביטוח והנם באחריות מלאה של נותני השירות .</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">ט.ל.ח</span></li>\r\n</ul>\r\n",
                "includeCustomerInfo": false,
                "isFullDay": false,
                "forTreatmentById": null,
                "forTreatmentBy": null,
                "belongsToId": null,
                "belongsTo": null,
                "employer": null,
                "employerId": null,
                "riderId": null,
                "rider": null,
                "status": null,
                "assignmentStatusType": 0,
                "whatsAppMessageId": null,
                "treatmentActivities": [],
                "treatmentTypeIcon": "fa-mobile-alt",
                "upsertActionName": "UpsertSmsTreatment",
                "FileAttachments": [],
                "seen": false
            }
            console.log('newTreatment', newTreatment);
            dispatch(setTask(newTreatment));
        } else {
            const data = await customerCardModel.getAssignment(id);
            await customerCardModel.setAssignmentSeen(id);

            console.log('data getAssignment', id, data)
            if (treatmentsList) {
                const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
                treatmentsList[taskIndex].seen = true;
                setTreatmentsList(treatmentsList);
            }
            if (String(data.endDate).startsWith('0001-01-01')) {
                data.endDate = new Date();
            }
            // set data to redux store for use in the popup
            console.log('data', data);
            dispatch(setTask(data));
            dispatch(setPopUpTreatmentModel({ show: true, type: 1 }));
            // setSelectedAssigment(data);
        }
        // setShowAddTreatmentPopup(true)
    }

    const editEmail = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
        dispatch(setPopUpTreatmentModel({ show: true, type: 3 }));

    }

    const editDoc = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
        dispatch(setPopUpTreatmentModel({ show: true, type: 4 }));
        dispatch(setTreatmentId(id));

    }


    const showHideSendEmailPopup = (show: boolean) => {
        setShowSendEmailPopUp(show);
    }
    const showHideSendWhatsAppPopup = (show: boolean) => {
        setShowSendWhatsAppPopUp(show);
    }


    const sendEmail = (id: string) => {
        showHideSendEmailPopup(true)
    }

    const sendWhatsApp = (id: string) => {
        showHideSendWhatsAppPopup(true)
    }

    const emptyFunc = (t?: any, v?: any) => { }


    const setStatus = (id: string, status: string) => {
        customerCardModel.setAssignmentStatus(id, status).then((res: any) => {
            getTreatments();
        })
    }

    const updateSeen = async (id: string) => {
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
    }

    const deleteAssigment = (id: string) => {
        // console.log('deleteAssigment');
        // if(props.actions && props.actions.delete) {
        //     props.actions.delete(id);
        // }
        console.log('deleteAssigmentid', id)
        if (id && id != '') {
            setAssignmentIdForDelete(id);
            setShowDeleteAssignmentPopup(true);
            // 
        }
    }

    const onApproveDeleteAssignment = async (id: string) => {
        // setLoading(true)
        await customerCardModel.deleteAssigment(id);
        setAssignmentIdForDelete(null);
        setShowDeleteAssignmentPopup(false);
        console.log('onApproveDeleteAssignment', id)
        // setLoading(false);
        getTreatments();

        setPopupMessageContent('המשימה נמחקה בהצלחה');
        setPopupMessageTitle('מחיקת משימה');
    }

    const hideDeleteAssingmentPopup = () => {
        setShowDeleteAssignmentPopup(false)
    }

    const addOfferOptions: MenuProps['items'] = [
        // {
        //     key: '0',
        //     label: (
        //         <div className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._0) }}
        //         >
        //             תיעוד שיחה
        //         </div>
        //     ),
        // },
        // {
        //     key: '3',
        //     label:
        //         <div className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._3) }}
        //         >
        //             תיעוד דוא"ל
        //         </div>,
        // },
        // {
        //     key: '4',
        //     label:
        //         <li className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._4) }}
        //         >
        //             תיעוד
        //         </li>,
        // },
        // {
        //     key: '6',
        //     label:
        //         <li className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._6) }}
        //         >
        //             מכתב
        //         </li>,
        // },
        {
            key: '1',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}
                >
                    משימה
                </li>,
        },
        {
            key: '2',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._2) }}
                >
                    וואצפ
                </li>,
        },

    ];


    return (
        <>

            {
                showSendEmailPopUp &&
                <TasksSendEmailPopup
                    ShowHidePopup={showHideSendEmailPopup}
                    type={1}
                    ClosePopup={() => showHideSendEmailPopup(false)}
                />
            }


            {
                showSendWhatsAppPopUp &&
                <TasksSendWhatsAppPopup
                    // messageTitle={newTreatmentType.toString()}
                    ShowHidePopup={showHideSendWhatsAppPopup}
                    type={1}
                    ClosePopup={() => showHideSendWhatsAppPopup(false)}
                />
            }
            {/* {
                documentUrl && (
                    <LeadDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            } */}
            {
                documentUrl && documentUrl.length > 0 && (
                    <TaskDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            }

            {
                showDeleteAssignmentPopUp && <ConfirmPopUp
                    data={assignmentIdForDelete}
                    messageTitle={'מחיקת משימה'}
                    message={'האם את/ה בטוח?'}
                    OnApprove={onApproveDeleteAssignment}
                    ClosePopup={hideDeleteAssingmentPopup} />
            }

            <div className="content-body">
                <div className="flex-space-between">
                    <div className="filter-row flex-centered client-search">
                        <div className="filter-input search">
                            <input type="text" value={treatmentsSeachText} placeholder="חיפוש" onChange={handleTreatmentSearchChange} />
                            <div className="icon search"></div>
                        </div>
                        <div className="filter-input select treatment-type-select">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="בחר קטגוריה"
                                value={treatmentSeachType}
                                onChange={setFilterTreatmentType}
                                options={[
                                    {
                                        label: 'כל הסוגים',
                                        value: '-1'
                                    },
                                    {
                                        label: 'שיחות',
                                        value: '0'
                                    },
                                    {
                                        label: 'משימות',
                                        value: '1'
                                    },
                                    {
                                        label: 'וואצפ',
                                        value: '2'
                                    },
                                    {
                                        label: 'מייל',
                                        value: '3'
                                    },
                                    {
                                        label: 'תיעוד',
                                        value: '4'
                                    },
                                    {
                                        label: 'מכתב',
                                        value: '6'
                                    },
                                ]}
                            />
                        </div>
                        <div className="filter-input select">
                            <Select
                                showSearch
                                optionFilterProp="label"
                                style={{ width: '100%' }}
                                value={treatmentSearchHandledBy}
                                onChange={(value: string) => onTreatmentHandlerChange(value)}
                                onSearch={onSearchHandler}
                                options={handlersOptions}
                            />
                        </div>
                        <div className="filter-input select">
                            <Select
                                showSearch
                                optionFilterProp="label"
                                style={{ width: '100%' }}
                                value={treatmentSearchCreatedBy}
                                onChange={(value: string) => onTreatmentCreatorChange(value)}
                                onSearch={onSearchCreator}
                                options={creatorsOptions}
                            />
                        </div>
                        <div className="filter-row flex-centered advanced-search">
                            <div className="search-input" style={{ display: 'flex' }}>
                                <div className="label">
                                    טווח
                                </div>
                                <div className="filter-input">
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="בחר טווח"
                                        value={treatmentsPeriod}
                                        onChange={(value: string, option: any) => onTreatmentPeriodChange(value, option)}
                                        options={
                                            [
                                                {
                                                    label: 'הכל',
                                                    value: '-1'
                                                },
                                                {
                                                    label: '3 חודשים',
                                                    value: '3months'
                                                },
                                                {
                                                    label: '6 חודשים',
                                                    value: '6months'
                                                },
                                                {
                                                    label: '12 חודשים',
                                                    value: '12months'
                                                },
                                                {
                                                    label: '3 שנים',
                                                    value: '3years'
                                                },
                                            ]
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="filter-row flex-centered advanced-search">

                            <div className="search-input" style={{ display: 'flex' }}>
                                <div className="label">
                                    מ:
                                </div>
                                <div className="filter-input select">
                                    <CompDatePicker value={treatmentsStartDate} onChange={(date: Date) => onTreatmentStartDateChange(date)} />
                                </div>
                            </div>
                            <div className="search-input" style={{ display: 'flex' }}>
                                <div className="label">
                                    עד:
                                </div>
                                <div className="filter-input select">
                                    <CompDatePicker value={treatmentsEndDate} onChange={(date: Date) => onTreatmentEndDateChange(date)} />
                                </div>
                            </div>
                        </div>
                        <div className="filter-button">
                            <div className="icon refresh-counter pointer" onClick={clearTreatmentsFliter}></div>
                        </div>
                    </div>
                    <div className='flex-centered'>
                        <Dropdown menu={{ items: addOfferOptions }}>
                            <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                <div className="icon add"></div>
                                Add
                            </button>
                        </Dropdown>
                        {/* <div className="icon gear"></div> */}

                        <div className="icon icon-config gear pointer" onClick={props.showTreatmentConfigPopup}></div>
                    </div>
                </div>

                {treatmentsList ? (
                    <TasksTable data={treatmentsList} className='big' fromLeads={false}
                    fromClient={true}

                        actions={{
                            edit: (id: string) => editTask(id),
                            editEmail: (id: string) => editEmail(id),
                            editDoc: (id: string) => editDoc(id),
                            sendEmail: (id: string) => sendEmail(id),
                            sendWhatsApp: (id: string) => sendWhatsApp(id),
                            print: (id: string) => emptyFunc(),
                            setStatus: (id: string, newStatus: string) => setStatus(id, newStatus),

                            delete: (id: string) => deleteAssigment(id),
                            onSortChange: (id: string) => emptyFunc(),
                            onShowDocument: (url: any[]) => onShowDocumentPopUp(url),
                            // redirectToClient: (id: string) => redirectToClient(id),
                            updateSeen: (id: string) => updateSeen(id)
                        }}
                    />
                ) : (<></>)}
            </div>
            <footer className="footer emails-list-footer emails-list-view">
                <Pagger pagerConf={treatmentsPagerConf} changePage={() => console.log(1)} refresh={() => console.log(1)}></Pagger>
            </footer>
        </>
    )
}

export default TasksClientDetails